module.exports = __webpack_public_path__ + "static/media/success-check.12cee0a2.svg";